<template>
  <el-dialog title="设置链接内容" :visible="linkStatue" @close="closeDialog" width="800px" append-to-body>
    <div class="view-flex">
      <div class="link-data">
        <Finder
          v-if="type !== 'category' && type !== 'marketing' && type !== 'link'"
          :type="type"
          @onSearch="handleSearch">
          <div v-if="type === 'goods' || type === 'article' || type === 'planting'" class="store view-flex-item">
            <StoreFilter :data="store" @change="handleStoreChange"/>
          </div>
        </Finder>
        <List
          :type="type"
          :store="store"
          :keywords="keywords"
          @onClick="handleRowClick"
          />
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="setComfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import Finder from './comps/finder'
  import List from './comps/link'
  import StoreFilter from '../function/storeFilter'

  export default {
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      usage: {
        type: String,
        default: 'wxapp' // 'wxapp'小程序端，'pc'pc端装修
      },
      links:{
        type: Array,
        default: function(){
          return []
        }
      }
    },
    components: {
      Finder,
      List,
      StoreFilter
    },
    watch: {
      visible (val) {
        if (val) {
          this.linkStatue = val
        }
      }
    },
    data () {
      return {
        linkStatue: false,
        type: 'custom_link',
        link: '',
        keywords: '',
        showStore: false,
        store: {}
      }
    },
    methods: {
      handleTabsClick (val) {
        if (this.type === val) return
        this.type = val
        this.keywords = ''
      },
      handleSearch (val) {
        this.keywords = val
      },
      handleRowClick (val) {
        this.link = val
        this.$emit('linkChoose', val)
      },
      handleStoreChange (val) {
        this.store = val
      },
      closeDialog () {
        this.linkStatue = false
        this.$emit('closeDialog', 'link')
      },
      setComfirm () {
        if (!this.link) {
          this.$message({
            message: '请选绑定内容',
            type: 'error'
          })
          return
        }
        this.$emit('setLink', this.link, this.type,false)
        this.linkStatue = false
      }
    }
  }
</script>

<style scoped lang="scss">
  .store {
    margin-right: 20px;
  }
  .link-data {
    flex: 1;
    padding-left: 30px;
  }
</style>
i



// WEBPACK FOOTER //
// link.vue?5e791eba